import React from "react";

/* Pure SVG icons used in CTA buttons so they render identically on every device.
   Avoid color emojis (📞 💬 🚐) which fall back to monochrome glyphs on systems
   without a color emoji font (some Android, older Windows, Linux servers). */

export const PhoneIcon = ({ size = 18, color = "currentColor" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z" />
  </svg>
);

export const WhatsAppIcon = ({ size = 18, color = "currentColor" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill={color}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39-.301 0-2.04-.875-3.51-2.31-1.135-1.137-2.085-2.93-2.085-3.23 0-.43 1.39-1.146 1.39-1.518 0-.075-.85-2.5-1.169-3.27-.198-.495-.508-.546-.86-.546-.196 0-.4-.026-.6-.026-.21 0-.55.078-.84.382-.296.31-1.105 1.084-1.105 2.64 0 1.558 1.13 3.058 1.282 3.265.155.21 2.156 3.43 5.32 4.694 2.633 1.05 3.17.838 3.74.787.572-.05 1.847-.756 2.106-1.486.258-.73.258-1.356.18-1.487-.078-.13-.286-.21-.6-.36zM16.01 5.013c-6.075 0-11 4.926-11 11 0 1.946.516 3.86 1.495 5.532L5 27.013l5.62-1.473A10.95 10.95 0 0 0 16.01 27.013c6.074 0 11-4.926 11-11s-4.926-11-11-11zm0 19.778A8.79 8.79 0 0 1 11.1 23.31l-.353-.212-3.65.956.974-3.56-.23-.37A8.787 8.787 0 0 1 7.22 16.013c0-4.851 3.94-8.789 8.79-8.789 4.851 0 8.79 3.938 8.79 8.789 0 4.85-3.939 8.789-8.79 8.789z" />
  </svg>
);

export const VanIcon = ({ size = 18, color = "currentColor" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M3 6h11v10H3z" />
    <path d="M14 9h4l3 4v3h-7z" />
    <circle cx="7.5" cy="17.5" r="1.8" fill={color} stroke="none" />
    <circle cx="17" cy="17.5" r="1.8" fill={color} stroke="none" />
  </svg>
);
